var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-big",
      attrs: {
        visible: _vm.visible,
        "close-on-click-modal": false,
        top: "5px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeForm,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("span", { staticClass: "el-dialog__title" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("common.refund")))]),
          _vm._v(
            "\n      - " +
              _vm._s(_vm._f("capitalize")(_vm.currentProduct.description)) +
              "\n      - " +
              _vm._s(_vm.device.mac_address || _vm.device.device_id) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.submitting,
              expression: "submitting",
            },
          ],
        },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.active,
                "finish-status": "success",
                "align-center": "",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "Customer", description: "Details" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Product", description: "Details" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Extra", description: "Information" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Review", description: "Before submit" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Summary", description: "request" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-content" }, [
            _vm.active === 0
              ? _c(
                  "div",
                  [
                    _vm.visible
                      ? _c("customer-request-customer-step", {
                          ref: "customerStep",
                          attrs: { device: _vm.device },
                          on: {
                            next: function ($event) {
                              return _vm.nextStep(1)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 1
              ? _c(
                  "div",
                  [
                    _c("customer-request-refund-reason-step", {
                      attrs: { device: _vm.device },
                      on: {
                        back: function ($event) {
                          return _vm.backStep(0)
                        },
                        next: function ($event) {
                          return _vm.nextStep(2)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 2
              ? _c(
                  "div",
                  [
                    _c("customer-request-misc-step", {
                      attrs: { device: _vm.device },
                      on: {
                        back: function ($event) {
                          return _vm.backStep(1)
                        },
                        next: function ($event) {
                          return _vm.nextStep(3)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 3
              ? _c(
                  "div",
                  [
                    _c("customer-request-review-step", {
                      on: {
                        back: function ($event) {
                          return _vm.backStep(2)
                        },
                        submit: function ($event) {
                          return _vm.submit()
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 4
              ? _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("h4", { staticClass: "request-panel-title" }, [
                              _vm._v("\n              Request\n            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Request ID")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.uuid) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("State")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.newRequest.state
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Old Product")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.newRequest.old_product.description
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Product")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.newRequest.product.description
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Agent")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.agent.email) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Reasons")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _c(
                                    "ul",
                                    { staticClass: "reasons-resume" },
                                    _vm._l(
                                      _vm.newRequest.request_reasons,
                                      function (rr) {
                                        return _c(
                                          "li",
                                          {
                                            key: rr.reason.table.reason_id,
                                            staticClass: "reason-row",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    rr.reason.table.text
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Created")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 16 } },
                                  [
                                    _c("time-zone-formatter", {
                                      attrs: {
                                        "current-time":
                                          _vm.newRequest.created_at,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("h4", { staticClass: "request-panel-title" }, [
                              _vm._v("\n              Customer\n            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Name")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_name) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Email")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_email) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Phone")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_phone) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("b", [_vm._v("Address")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.newRequest.customer_address_1
                                      ) +
                                      ",\n                "
                                  ),
                                  _vm.newRequest.customer_address_2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.newRequest.customer_address_2
                                          ) + ","
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_city) +
                                      "\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_zip) +
                                      ",\n                " +
                                      _vm._s(_vm.newRequest.customer_state) +
                                      ",\n                " +
                                      _vm._s(_vm.newRequest.customer_country) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.shouldShowReturnMessage(_vm.newRequest)
                              ? _c(
                                  "el-alert",
                                  {
                                    attrs: { type: "warning", closable: false },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "\n                Important note that requests for "
                                      ),
                                      _c("b", [_vm._v("non-domestic U.S.")]),
                                      _vm._v(
                                        " addresses will not receive a label email from UPS. Manual submission of return label required.\n              "
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "center-buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.closeForm()
                              },
                            },
                          },
                          [_vm._v("\n            Finish\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showCopyModal()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Copy Request Information\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("CustomerRequestCopyData", {
                      ref: "copyRequestModal",
                      attrs: { request: _vm.newRequest },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }